var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"site-app-main"},[_c('section',[_c('keep-alive',[_c('router-view')],1)],1),_c('site-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }